import { IEnumDto } from "../interfaces/funderInvestment";

/**
 * A tenor with its unit, e.g. "90 days" or "6 months".
 *
 * The backend sends the unit three ways: an `EnumDto` on the details and
 * investor lists, the enum's name on the all-investments query, and nothing
 * at all on older rows — which were always days. Every table used to print
 * "{tenure} days", which is wrong for a plan booked in months.
 */

/** `Enums.DepositPeriodFrequency`. */
const UNIT_BY_VALUE: Record<number, string> = {
  0: "day",
  1: "week",
  2: "month",
  3: "year",
};

const UNIT_BY_NAME: Record<string, string> = {
  days: "day",
  weeks: "week",
  months: "month",
  years: "year",
};

const EMPTY = "—";

export function formatTenor(
  tenure: number | null | undefined,
  tenorUnit?: IEnumDto | string | number | null,
): string {
  if (tenure === null || tenure === undefined || Number.isNaN(Number(tenure))) {
    return EMPTY;
  }

  const unit = toUnit(tenorUnit);
  const count = Number(tenure);

  return `${count} ${unit}${count === 1 ? "" : "s"}`;
}

function toUnit(tenorUnit?: IEnumDto | string | number | null): string {
  if (tenorUnit === null || tenorUnit === undefined || tenorUnit === "") {
    return "day";
  }

  if (typeof tenorUnit === "number") {
    return UNIT_BY_VALUE[tenorUnit] ?? "day";
  }

  if (typeof tenorUnit === "string") {
    return UNIT_BY_NAME[tenorUnit.toLowerCase()] ?? "day";
  }

  return (
    UNIT_BY_VALUE[tenorUnit.value] ??
    UNIT_BY_NAME[String(tenorUnit.name).toLowerCase()] ??
    "day"
  );
}
